import { Button, Form, Tooltip } from "antd";
import TextArea from "antd/es/input/TextArea";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import PropTypes from "prop-types";
import useUser from "../../../hooks/useUser";
import FormItem from "antd/es/form/FormItem";
import useToast from "../../../hooks/userToast";

StudyTextModal.propTypes = {
  studyPrimaryKey: PropTypes.number,
  handleOk: PropTypes.func,
  fetchData: PropTypes.func,
};

function StudyTextModal({ studyPrimaryKey, handleOk, fetchData }) {
  const [boxData, setBoxData] = useState([]);
  const [editableRemarks, setEditableRemarks] = useState({});
  const [isCreateRemark, setISCreateRemark] = useState(false);
  const [editText, setEditText] = useState({});
  const { userID, role } = useUser();
  const { toastError, toastSuccess } = useToast();

  const getAllRemarks = async () => {
    try {
      const response = await apiClient.get(
        `study-remark?studyInfoId=${studyPrimaryKey}`
      );
      setBoxData(response?.data?.StudyRemark?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllRemarks();
  }, []);

  const deleteRemark = async (id) => {
    try {
      await apiClient.delete(`study-remark/${id}`);
      setEditableRemarks((prev) => ({ ...prev, [id]: false }));
      toastSuccess("History Updated Successfully");
      await handleOk();
      if (fetchData) await fetchData();
    } catch (error) {
      console.log("error-->", error);
    }
  };
  const handleUpdateRemark = async (id) => {
    try {
      const formData = {
        id_study_info_model: studyPrimaryKey,
        reference_id: userID,
        remark: editText[id],
        studyRemarkId: id,
      };
      await apiClient.post("study-remark/create", formData);
      setEditableRemarks((prev) => ({ ...prev, [id]: false }));
      toastSuccess("History Updated Successfully");
      await handleOk();
      if (fetchData) await fetchData();
    } catch (error) {
      toastError("Error Updating History", error);
    }
  };

  const handleEdit = (id, remark) => {
    setEditableRemarks((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));

    setEditText((prev) => ({
      ...prev,
      [id]: remark,
    }));
  };

  const noUserRemarks = boxData.every(
    (element) => element.reference_id !== userID
  );

  const handleNewRemark = async (values) => {
    try {
      const formData = {
        id_study_info_model: studyPrimaryKey,
        reference_id: userID,
        remark: values.newRemark,
        role_name: role,
      };
      await apiClient.post("study-remark/create", formData);
      await handleOk();
      if (fetchData) await fetchData();
      await toastSuccess("Added History Succesfully");
    } catch (error) {
      toastError("Error Adding History", error);
    }
  };

  return (
    <>
      <div>
        {boxData?.map((element) => {
          const isEditable = editableRemarks[element.id] || false;
          return (
            <div className="mb-3" key={element?.id}>
              <div className="add_descriptions">
                <b className="mx-1" style={{ color: "#016fb9" }}>
                  {element?.role_name}
                </b>
                <span>-</span>
                {/* <p>{element?.role_name}</p> */}
              </div>
              <div className="d-flex edit_descrption_textarea">
                <div style={{ width: "500px" }}>
                  <Form>
                    <FormItem>
                      <TextArea
                        disabled={!isEditable}
                        autoSize={{ minRows: 2, maxRows: 8 }}
                        value={
                          isEditable ? editText[element.id] : element?.remark
                        }
                        onChange={(e) =>
                          setEditText((prev) => ({
                            ...prev,
                            [element.id]: e.target.value,
                          }))
                        }
                      />
                    </FormItem>
                  </Form>
                </div>{" "}
                <div style={{ width: "200px" }}>
                  {element.reference_id === userID && (
                    <>
                      <Tooltip title="Edit Description">
                        <EditOutlined
                          style={{ marginLeft: 10, cursor: "pointer" }}
                          onClick={() =>
                            handleEdit(element.id, element?.remark)
                          }
                        />
                      </Tooltip>{" "}
                      <Tooltip title="Delete Description">
                        <DeleteOutlined
                          style={{ marginLeft: 10, cursor: "pointer" }}
                          onClick={() => deleteRemark(element.id)}
                        />
                      </Tooltip>
                      {editableRemarks[element.id] && (
                        <Button
                          type="primary"
                          onClick={() => handleUpdateRemark(element.id)}
                          style={{ marginLeft: 10, marginTop: 10 }}
                        >
                          Submit
                        </Button>
                      )}
                    </>
                  )}{" "}
                </div>
              </div>
            </div>
          );
        })}

        {noUserRemarks && (
          <>
            {!isCreateRemark && (
              <>
                <p
                  style={{
                    textAlign: "center",
                    color: "red",
                    fontSize: "15px",
                  }}
                >
                  You have not provided any history to this study.
                </p>
                <div className="d-flex justify-content-center mb-2">
                  <Button
                    className="create_add_remark"
                    onClick={() => {
                      setISCreateRemark(true);
                    }}
                  >
                    Add History
                  </Button>
                </div>
              </>
            )}

            {isCreateRemark && (
              <div>
                <Form onFinish={handleNewRemark}>
                  <FormItem
                    name="newRemark"
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <TextArea
                      autoSize={{ minRows: 2, maxRows: 8 }}
                      className="form-control"
                    />
                  </FormItem>

                  <div className="d-flex justify-content-center my-2">
                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                  </div>
                </Form>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default StudyTextModal;
